import { observer } from 'mobx-react-lite'
import { layoutStore } from 'shared/layout'
import { bannerStore } from 'shared/ui'
import { TrialSubscriptionBanner } from 'entities/Subscription/ui/TrialSubscriptionBanner/ui/TrialSubscriptionBanner'
import { CanceledSubscriptionBanner } from 'entities/Subscription/ui/CanceledSubscriptionBanner/ui/CanceledSubscriptionBanner'
import { CallingBanner } from 'entities/Compliance/ui/CallingBanner/ui/CallingBanner'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { LandlineBanner } from 'entities/Phone/ui/LandlineBanner'
import { IntegrationBanner } from 'entities/Integrations/ui/IntegrationBanner'
import { AutorechargeFailureBanner } from 'entities/Billing/ui/AutorechargeFailureBanner'
import { NotificationsBanner } from 'entities/Notifications'

export const GlobalBanners = observer(() => {
  const { authStore } = useEntitiesContext()

  if (
    bannerStore.disabledGlobal ||
    layoutStore.isMobileView ||
    !authStore.isLoggedIn ||
    !authStore.isRefresh
  )
    return null

  return (
    <>
      <TrialSubscriptionBanner />
      <CanceledSubscriptionBanner />
      <CallingBanner />
      <LandlineBanner />
      <IntegrationBanner />
      <AutorechargeFailureBanner />
      <NotificationsBanner />
    </>
  )
})
